import { RootState } from 'reduxStore/types';

export const getModalState = (state: RootState) => state?.modal;
